"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCartDetailsCB = exports.setCartDetails = exports.setCartAttributes = exports.addCartAttributes = exports.setCartNote = void 0;
var queue_1 = require("./queue");
var get_1 = require("./get");
var events_1 = require("./events");
var jquery_1 = require("../jquery");
var setCartNote = function (note) { return (0, exports.setCartDetails)(undefined, note); };
exports.setCartNote = setCartNote;
var addCartAttributes = function (attributes) { return (0, exports.setCartDetails)(attributes); };
exports.addCartAttributes = addCartAttributes;
var setCartAttributes = function (attributes) {
    var cart = (0, get_1.getCurrentCart)();
    cart.attributes = cart.attributes || {};
    Object.keys(cart.attributes).forEach(function (key) { return attributes[key] = ''; });
    return (0, exports.setCartDetails)(attributes);
};
exports.setCartAttributes = setCartAttributes;
var setCartDetails = function (attributes, note) {
    return new Promise(function (resolve, reject) { return (0, exports.setCartDetailsCB)(attributes, note, resolve, reject); });
};
exports.setCartDetails = setCartDetails;
var setCartDetailsCB = function (attributes, note, callback, errorCallback) {
    //A null note will be undefined (so it won't update), use "" instead for empty.
    if (note == null)
        note = undefined;
    var o = {
        callback: callback,
        errorCallback: errorCallback,
        url: "/cart.js",
        method: 'POST',
        dataType: 'json',
        data: { note: note, attributes: attributes },
        action: 'details'
    };
    o.success = function (data) {
        (0, get_1.setCurrentCart)(data); //The returned value is the full cart, we can use it to update the cart
        if (this.callback)
            this.callback(data);
        (0, queue_1.addFinishTrigger)({ event: events_1.ON_DETAILS_SET, data: data });
        (0, queue_1.addFinishTrigger)({ event: events_1.ON_CART_FETCHED, data: data });
        (0, queue_1.removeTask)(this);
        (0, queue_1.nextTask)();
    }.bind(o);
    o.error = function (e, i, a) {
        if (this.errorCallback)
            this.errorCallback(e ? e.responseJSON || e : 'Unknown Error');
        (0, queue_1.removeTask)(this);
        (0, queue_1.errorQueue)();
    }.bind(o);
    o.task = function () {
        jquery_1.jq.ajax(this);
    }.bind(o);
    (0, queue_1.addTask)(o);
};
exports.setCartDetailsCB = setCartDetailsCB;
//# sourceMappingURL=details.js.map